import FinalWizardScreen from "./FinalWizardScreen";

export default FinalWizardScreen;
